import {Modal} from "../Modal.jsx";
import {useState} from "react";
import {getTranslations} from "../../services/language.service.js";

const LANG = getTranslations()

export const SpecialisedInformationResult = (props) => {
    const [showModal,setShowModal] = useState(false)
    const getTeaser = () => {
        const teaser = <div className="text" dangerouslySetInnerHTML={{__html: props.result.teaser}}/>

        if (props.result.locked) {
            return teaser
        }

        return <>{teaser}</>
    }

    const onClick = (e) => {
        if (showModal) {
            return
        }
        e.preventDefault()
        setShowModal(true)
    }

    let download = false;
    if (props.result.specialisedInformationType === 'download') {
        download = props.result.filename;
    }

    return (
        <a href={props.result.url} title={props.result.title}
           className={"um-sheet" + (props.result.image !== '' ? ' um-sheet--image' : '') + (props.result.stickyNews ? ' bg-primary' : ' bg-grey') + (props.result.locked ? ' article--locked' : '')}
           onClick={props.result.locked ? onClick : undefined} download={download}>
            {props.result.image !== '' && <div className="image">
                <img src={props.result.image} alt={props.result.title}
                     style={{objectFit: 'cover', width: '100%', height: '100%'}}/>
            </div>}
            <div className="content">
                <div className="info">
                    {props.result.publishedAt}
                    <span className="news-list-category"> | {props.result.category}</span>
                </div>
                <div className="headline_3">
                    {props.result.title}
                </div>

                <div className="text">
                    {getTeaser()}
                </div>

                <div className="bottom">
                    <div className="news-list-tags">
                        {props.result.tags.map(tag =>
                            <span>{tag}</span>
                        )}
                    </div>
                </div>

                <div className="bottom">
                    {props.result.specialisedInformationType === 'download' &&
                        <span className="link link--download">PDF
                            Download</span>}
                    {props.result.specialisedInformationType === 'page' &&
                        <span className="link link--arrow">{LANG.readArticle}</span>}

                    <div>
                        {props.result.readingTime !== '' ?
                            <span dangerouslySetInnerHTML={{__html: props.result.readingTime}}/> : ''}
                    </div>
                </div>
            </div>
            {(showModal) &&
                <Modal userRoles={props.result.userRoles} setShowModal={setShowModal} loginUrl={props.result.loginUrl} download={download}></Modal>
            }
        </a>
    )
}
